import { payekoohFeatureScreens } from './payekoohFeatureScreens'

export type Locale = 'fa' | 'en'

export const payekoohCafeBazaarUrl = 'https://cafebazaar.ir/app/com.payekooh_app'

export type Product = {
  slug: string
  index: string
  name: Record<Locale, string>
  category: Record<Locale, string>
  summary: Record<Locale, string>
  description: Record<Locale, string>
  metric: Record<Locale, string>
  metricLabel: Record<Locale, string>
  accent: 'blue' | 'orange' | 'green'
  features: Record<Locale, string[]>
  marketplaceUrl?: string
  websiteUrl?: string
  showcaseImages?: Array<{ src: string; alt: Record<Locale, string> }>
}

export const products: Product[] = [
  {
    slug: 'payekooh-app',
    index: '01',
    name: { fa: 'اپلیکیشن پایه‌کوه', en: 'Payekooh App' },
    category: { fa: 'محصول دیجیتال · فضای باز', en: 'Digital product · Outdoors' },
    summary: {
      fa: 'پایه‌کوه، اپلیکیشن نقشه‌محور برای ثبت فعالیت، مرور مسیرها و تجربه کوهنوردی است.',
      en: 'Payekooh is a map-first outdoor app for recording activities and revisiting routes.',
    },
    description: {
      fa: 'طراحی تجربه کاربری، توسعه اپلیکیشن و نگهداری فنی پایه‌کوه توسط تیم پایه گستران هوشمند انجام می‌شود.',
      en: 'Paye Gostaran Hooshmand handles Payekooh’s product design, app development, and ongoing technical maintenance.',
    },
    metric: { fa: 'MAP', en: 'MAP' },
    metricLabel: { fa: 'نقشه و ثبت فعالیت', en: 'maps and activities' },
    accent: 'blue',
    marketplaceUrl: payekoohCafeBazaarUrl,
    showcaseImages: [
      {
        src: '/images/payekooh/activity-map.webp',
        alt: { fa: 'نمای ثبت فعالیت و مسیر روی نقشه در اپلیکیشن پایه‌کوه', en: 'Payekooh activity tracking and route map' },
      },
      {
        src: '/images/payekooh/saved-routes.webp',
        alt: { fa: 'نمای مسیرهای ذخیره‌شده در اپلیکیشن پایه‌کوه', en: 'Saved routes in the Payekooh app' },
      },
      {
        src: '/images/payekooh/terrain-map.webp',
        alt: { fa: 'نمای سه‌بعدی مسیر کوهستانی در اپلیکیشن پایه‌کوه', en: 'Three-dimensional mountain route in the Payekooh app' },
      },
      ...payekoohFeatureScreens.map((screen) => ({
        src: screen.image,
        alt: screen.title,
      })),
    ],
    features: {
      fa: ['نقشه و نمایش مسیر', 'ثبت و مرور فعالیت', 'مسیرهای ذخیره‌شده', 'نگهداری و توسعه اپلیکیشن'],
      en: ['Maps and tracks', 'Activity records', 'Saved routes', 'Ongoing mobile development'],
    },
  },
  {
    slug: 'payepoosh',
    index: '02',
    name: { fa: 'فروشگاه پایه‌پوش', en: 'Payepoosh Store' },
    category: { fa: 'تجارت الکترونیک · پوشاک', en: 'Commerce · Apparel' },
    summary: {
      fa: 'پایه‌پوش؛ برند فروش پوشاک و تجهیزات کوهنوردی و طبیعت‌گردی در اکوسیستم پایه‌گستران.',
      en: 'Payepoosh is the outdoor apparel and equipment retail brand within Paye Gostaran.',
    },
    description: {
      fa: 'هویت بصری، تجربه خرید و توسعه فنی فروشگاه پایه‌پوش در داخل تیم انجام شده است.',
      en: 'The brand identity, shopping experience, and technical development of Payepoosh were produced in-house.',
    },
    metric: { fa: 'E–COM', en: 'E–COM' },
    metricLabel: { fa: 'طراحی تا توسعه فروشگاه', en: 'store design to delivery' },
    accent: 'orange',
    features: {
      fa: ['طراحی هویت بصری', 'طراحی تجربه خرید', 'توسعه فروشگاه اینترنتی'],
      en: ['Visual identity', 'Shopping experience design', 'Online store development'],
    },
  },
  {
    slug: 'payekooh-web',
    index: '03',
    name: { fa: 'وب‌سایت پایه‌کوه', en: 'Payekooh Web' },
    category: { fa: 'پلتفرم وب · محتوا', en: 'Web platform · Content' },
    summary: {
      fa: 'وب‌سایت رسمی پایه‌کوه، مسیر ورود از وب برای آشنایی با برند و خدمات اکوسیستم کوهنوردی.',
      en: 'The official Payekooh website introduces its brand and outdoor digital ecosystem.',
    },
    description: {
      fa: 'این وب‌سایت با تمرکز بر دسترسی سریع به اطلاعات، نمایش درست در موبایل و مدیریت ساده محتوا طراحی شده است.',
      en: 'The website focuses on quick access to information, reliable mobile layouts, and straightforward content management.',
    },
    metric: { fa: 'WEB', en: 'WEB' },
    metricLabel: { fa: 'سریع، واکنش‌گرا و محتوامحور', en: 'fast, responsive, content-led' },
    accent: 'green',
    websiteUrl: 'https://payekooh.ir/',
    features: {
      fa: ['طراحی واکنش‌گرا', 'ساختار و مدیریت محتوا', 'بهینه‌سازی عملکرد'],
      en: ['Responsive design', 'Content structure and management', 'Performance optimisation'],
    },
  },
]

export const copy = {
  fa: {
    nav: { services: 'خدمات', work: 'محصولات', process: 'فرایند', about: 'درباره ما', location: 'موقعیت دفتر', registration: 'مدارک ثبتی', contact: 'شروع همکاری' },
    hero: {
      titleA: 'ایده‌های شما را',
      titleB: 'دقیق و ماندگار',
      titleC: 'می‌سازیم',
      body: 'از تحلیل نیاز و طراحی هویت بصری تا برنامه‌نویسی وب‌سایت، اپلیکیشن، نرم‌افزار اختصاصی و اتوماسیون؛ راهکار دیجیتال شما را طراحی، اجرا و پشتیبانی می‌کنیم.',
      primary: 'شروع همکاری',
      secondary: 'نمونه‌کارها',
      assurances: ['پاسخ‌گویی 24 ساعته، 7 روز هفته', 'قرارداد رسمی و گزارش شفاف', 'مشاوره اولیه رایگان'],
    },
    services: {
      kicker: 'خدمات',
      titleA: 'از ایده تا ',
      titleAccent: 'هویت',
      titleB: ' و محصول دیجیتال',
      intro: 'طراحی گرافیک و هویت بصری، طراحی و ساخت انواع سایت، نرم‌افزار و اپلیکیشن موبایل؛ هر بخش متناسب با هدف کسب‌وکار شما شکل می‌گیرد.',
      allServices: 'مشاوره خدمات',
      more: 'اطلاعات بیشتر',
      catalogHint: 'حوزهٔ موردنیازتان را انتخاب کنید و مسیرهای آن را ببینید.',
      relatedWork: 'نمونه مرتبط',
      customPrompt: 'نیاز اختصاصی دارید؟',
      discuss: 'گفت‌وگو درباره پروژه',
      supportLabel: 'پیش از اجرا',
      supportTitle: 'به ایده‌ها ساختار می‌دهیم',
      supportBody: 'ایده‌ها و فرایندهای پراکنده را به یک مسیر روشن تبدیل می‌کنیم؛ سپس برای آن هویت بصری، تجربه کاربری و ابزارهای لازم را طراحی می‌کنیم.',
      supportLink: 'مسیر همکاری را ببینید',
    },
    work: {
      kicker: 'نمونه‌کارها',
      title: 'محصولات ما',
      more: 'مشاهده جزئیات',
    },
    process: {
      kicker: 'مراحل اجرا',
      title: 'شش قدم از ایده تا انتشار',
    },
    about: {
      kicker: 'درباره پایه گستران هوشمند',
      title: 'از طراحی خلاق تا مهندسی محصول دیجیتال',
      lead: 'پایه‌تک، برند فناوری شرکت پایه گستران هوشمند، در نقطه اتصال توسعه نرم‌افزار، طراحی محصول و رشد کسب‌وکار فعالیت می‌کند. ما ایده و مسئله را به وب‌سایت، اپلیکیشن، سامانه اختصاصی و تجربه دیجیتال کاربردی تبدیل می‌کنیم.',
      body: 'حوزه کار ما به نوشتن کد محدود نیست: تحلیل نیاز، معماری محصول، طراحی UI/UX، پیاده‌سازی فرانت‌اند و بک‌اند، یکپارچه‌سازی سرویس‌ها، استقرار و نگهداری را در کنار طراحی هویت بصری، گرافیک تبلیغاتی و بهبود فرایندهای کسب‌وکار پیش می‌بریم. تجربه توسعه مداوم محصولات خودمان، به‌ویژه پایه‌کوه، باعث شده تصمیم‌های فنی و بصری را با نگاه عملیاتی، بازخورد کاربران و پایداری بلندمدت بگیریم.',
      galleryTitle: 'نمای طراحی‌شده فضای شرکت',
      gallery: [
        { alt: 'رندر طراحی داخلی دفتر پایه‌تک با پیشخوان پذیرش، فضای کار و اتاق جلسه شیشه‌ای', caption: 'پذیرش و فضای همکاری' },
        { alt: 'رندر طراحی فضای شرکت پایه‌تک با میز کار، صندلی‌های مراجعه‌کنندگان و اتاق جلسات', caption: 'فضای جلسات و کار تیمی' },
      ],
      viewFullImage: 'نمایش تصویر در اندازه کامل',
    },
    registration: {
      kicker: 'مدارک ثبتی شرکت',
      title: 'مدارک ثبتی شرکت',
      intro: 'آگهی تأسیس شرکت پایه گستران هوشمند و نسخه منتشرشده در روزنامه رسمی را اینجا می‌توانید ببینید و دریافت کنید.',
      incorporationTitle: 'آگهی تأسیس',
      newspaperTitle: 'آگهی روزنامه رسمی',
      registrationNumber: 'شماره ثبت',
      registrationNumberValue: '921',
      nationalId: 'شناسه ملی شرکت',
      nationalIdValue: '14015755977',
      registrationDate: 'تاریخ ثبت',
      registrationDateValue: '1405/07/12',
      open: 'مشاهده فایل PDF',
      download: 'دریافت فایل',
      documentLabel: 'تصویر مدارک رسمی شرکت',
      previewAlt: 'تصویر صفحهٔ آگهی تأسیس شرکت پایه گستران هوشمند',
      newspaperPreviewAlt: 'تصویر آگهی تأسیس شرکت پایه گستران هوشمند در روزنامه رسمی',
    },
    contact: {
      kicker: 'تماس با ما',
      title: 'پروژه‌ای در ذهن دارید؟',
      body: 'برای گفت‌وگو درباره ایده، نیازها و مسیر اجرای پروژه، ایمیل بزنید یا مستقیم با ما تماس بگیرید.',
      email: 'ایمیل',
      projects: 'مشاوره، قرارداد و پیگیری پروژه‌ها',
      technical: 'توسعه و امور فنی پروژه‌ها',
      office: 'تلفن دفتر',
      messengers: 'پیام‌رسان‌ها',
      messengerNames: { eitaa: 'ایتا', rubika: 'روبیکا', bale: 'بله', telegram: 'تلگرام', instagram: 'اینستاگرام', linkedin: 'لینکدین' },
      openChat: 'باز کردن گفت‌وگو',
    },
    footer: 'طراحی و توسعه داده‌شده با دقت، در ایران.',
    back: 'بازگشت به محصولات',
    caseLabel: 'محصول اختصاصی',
    marketplaceAction: 'مشاهده در کافه‌بازار',
    websiteAction: 'مشاهده وب‌سایت',
    newTab: 'در برگهٔ جدید باز می‌شود',
    challenge: 'نگاه محصول',
    capabilities: 'قابلیت‌های کلیدی',
  },
  en: {
    nav: { services: 'Services', work: 'Products', process: 'Process', about: 'About', location: 'Location', registration: 'Company records', contact: 'Start a project' },
    hero: {
      titleA: 'We turn your ideas into',
      titleB: 'thoughtful, lasting',
      titleC: 'products',
      body: 'From strategy and visual design to websites, mobile apps, custom software and business automation, we create, launch and support useful digital solutions.',
      primary: 'Start a project',
      secondary: 'Our work',
      assurances: ['24/7 support', 'Formal contract and clear reporting', 'Free initial consultation'],
    },
    services: {
      kicker: 'Services',
      titleA: 'From an idea to a ',
      titleAccent: 'distinct',
      titleB: ' digital product',
      intro: 'Graphic design and visual identity, websites, software, and mobile apps: each service is shaped around your business goals.',
      allServices: 'Discuss your project',
      more: 'Explore options',
      catalogHint: 'Choose a field to explore the options available to you.',
      relatedWork: 'Related work',
      customPrompt: 'A custom requirement?',
      discuss: 'Discuss your project',
      supportLabel: 'Before the build',
      supportTitle: 'We give ideas structure',
      supportBody: 'We turn scattered ideas and workflows into a clear plan, then design the visual identity, user experience, and tools it needs.',
      supportLink: 'See our process',
    },
    work: {
      kicker: 'Selected work',
      title: 'Our products',
      more: 'View details',
    },
    process: {
      kicker: 'Delivery process',
      title: 'Six steps from idea to launch',
    },
    about: {
      kicker: 'About Paye Gostaran Hooshmand',
      title: 'Creative thinking. Product engineering. Lasting digital value.',
      lead: 'PayeTech is the technology brand of Paye Gostaran Hooshmand, bringing together software engineering, product design and business development. We turn ideas and operational challenges into useful websites, mobile applications, custom systems and digital experiences.',
      body: 'Our work goes beyond writing code. We connect discovery, product architecture, UX/UI, frontend and backend development, systems integration, deployment and ongoing maintenance with branding, graphic design, campaign assets and process improvement. Building and continuously evolving our own products — especially PayeKooh — gives our decisions a practical grounding in user feedback, real-world workflows and long-term product quality.',
      galleryTitle: 'Conceptual designs of our office',
      gallery: [
        { alt: 'Concept interior rendering of the PayeTech workspace with reception, workstations and a glass meeting room', caption: 'Reception & collaborative workspace' },
        { alt: 'Concept rendering of the PayeTech office showing guest seating, workstations and the meeting area', caption: 'Meetings & focused teamwork' },
      ],
      viewFullImage: 'Open full-size image',
    },
    registration: {
      kicker: 'Company records',
      title: 'Company records',
      intro: 'View and download the incorporation notice for Paye Gostaran Hooshmand and its publication in the official newspaper.',
      incorporationTitle: 'Incorporation notice',
      newspaperTitle: 'Official newspaper notice',
      registrationNumber: 'Registration number',
      registrationNumberValue: '921',
      nationalId: 'National entity ID',
      nationalIdValue: '14015755977',
      registrationDate: 'Registration date',
      registrationDateValue: '1405/07/12',
      open: 'Open PDF',
      download: 'Download PDF',
      documentLabel: 'Official company document previews',
      previewAlt: 'Preview of the Paye Gostaran Hooshmand incorporation notice',
      newspaperPreviewAlt: 'Preview of the Paye Gostaran Hooshmand notice in the official newspaper',
    },
    contact: {
      kicker: 'Contact',
      title: 'Have a project in mind?',
      body: 'Email or call us to discuss your idea, requirements, and a practical path for the project.',
      email: 'Email',
      projects: 'Consultation, contracts & project follow-up',
      technical: 'Development & technical matters',
      office: 'Office phone',
      messengers: 'Messengers',
      messengerNames: { eitaa: 'Eitaa', rubika: 'Rubika', bale: 'Bale', telegram: 'Telegram', instagram: 'Instagram', linkedin: 'LinkedIn' },
      openChat: 'Open chat',
    },
    footer: 'Designed and engineered with care in Iran.',
    back: 'Back to products',
    caseLabel: 'An owned product',
    marketplaceAction: 'View on Cafe Bazaar',
    websiteAction: 'Visit website',
    newTab: 'opens in a new tab',
    challenge: 'Product perspective',
    capabilities: 'Core capabilities',
  },
} as const

export const services = [
  {
    id: 'design', caseSlug: null, caseUrl: null,
    label: 'GRAPHIC & BRANDING',
    title: { fa: 'گرافیک و هویت بصری', en: 'Graphics & visual identity' },
    body: { fa: 'از سامان‌دهی ایده تا طراحی لوگو، هویت برند، اقلام گرافیکی و تجربهٔ بصری محصول.', en: 'From shaping an idea to logos, brand identity, graphic assets, and product visuals.' },
    caseName: null,
  },
  {
    id: 'web', caseSlug: 'payepoosh', caseUrl: null,
    label: 'WEB DESIGN',
    title: { fa: 'طراحی و توسعهٔ سایت', en: 'Website design & development' },
    body: { fa: 'سایت شرکتی، فروشگاهی یا اختصاصی؛ از طراحی رابط تا برنامه‌نویسی و انتشار.', en: 'Company sites, online stores, and custom websites, from interface to launch.' },
    caseName: { fa: 'فروشگاه پایه‌پوش', en: 'Payepoosh Store' },
  },
  {
    id: 'mobile', caseSlug: 'payekooh-app', caseUrl: payekoohCafeBazaarUrl,
    label: 'MOBILE APP',
    title: { fa: 'اپلیکیشن موبایل', en: 'Mobile applications' },
    body: { fa: 'طراحی و ساخت اپلیکیشن Android و iOS، با تجربهٔ کاربری روشن و مسیر توسعهٔ قابل‌گسترش.', en: 'Android and iOS applications with clear user journeys and room to grow.' },
    caseName: { fa: 'اپلیکیشن پایه‌کوه در بازار', en: 'Payekooh on Cafe Bazaar' },
  },
  {
    id: 'systems', caseSlug: null, caseUrl: null,
    label: 'CUSTOM SOFTWARE',
    title: { fa: 'نرم‌افزار و سامانه', en: 'Software & custom systems' },
    body: { fa: 'پنل مدیریت، وب‌اپلیکیشن و ابزار اختصاصی را بر پایهٔ فرایند واقعی کسب‌وکار می‌سازیم.', en: 'Admin panels, web apps, and custom tools built around real workflows.' },
    caseName: null,
  },
] as const

export const serviceCatalog = [
  {
    id: 'web',
    title: { fa: 'انواع وب‌سایت', en: 'Websites' },
    heading: { fa: 'کدام نوع سایت برای کسب‌وکار شما مناسب است؟', en: 'Which website fits your business?' },
    description: { fa: 'از یک معرفی ساده تا فروشگاه و سامانهٔ اختصاصی، ساختار سایت را بر اساس هدف و مخاطب شما انتخاب می‌کنیم.', en: 'From a simple introduction to a store or custom platform, the right structure follows your goals and audience.' },
    items: [
      { title: { fa: 'سایت فروشگاهی', en: 'Online store' }, description: { fa: 'فروش محصول و مدیریت سفارش', en: 'Sell products and manage orders' } },
      { title: { fa: 'سایت شرکتی', en: 'Company website' }, description: { fa: 'معرفی خدمات و اعتبار برند', en: 'Present services and build trust' } },
      { title: { fa: 'سایت اختصاصی', en: 'Custom website' }, description: { fa: 'متناسب با فرایند ویژهٔ شما', en: 'Tailored to your workflow' } },
      { title: { fa: 'سایت شخصی و نمونه‌کار', en: 'Portfolio website' }, description: { fa: 'نمایش حرفه‌ای توانایی و آثار', en: 'Showcase your work and skills' } },
      { title: { fa: 'سایت چندزبانه', en: 'Multilingual website' }, description: { fa: 'ارتباط با مخاطبان چند زبان', en: 'Reach audiences in multiple languages' } },
      { title: { fa: 'سایت خدماتی و رزرو', en: 'Service & booking site' }, description: { fa: 'معرفی خدمت و دریافت درخواست', en: 'Present services and accept bookings' } },
      { title: { fa: 'سایت آموزشی', en: 'Education website' }, description: { fa: 'معرفی دوره و مدیریت آموزش', en: 'Courses and learning management' } },
      { title: { fa: 'سایت پزشکی', en: 'Medical website' }, description: { fa: 'معرفی خدمات و نوبت‌دهی', en: 'Services and appointments' } },
      { title: { fa: 'لندینگ پیج', en: 'Landing page' }, description: { fa: 'معرفی یک محصول یا کمپین', en: 'Focus on one offer or campaign' } },
    ],
  },
  {
    id: 'mobile',
    title: { fa: 'اپلیکیشن موبایل', en: 'Mobile apps' },
    heading: { fa: 'اپلیکیشنی برای نیاز واقعی کاربران', en: 'An app built for real user needs' },
    description: { fa: 'از طراحی تجربهٔ کاربری تا ساخت و انتشار، امکانات اپلیکیشن را با مدل کسب‌وکار هماهنگ می‌کنیم.', en: 'We align the app experience, features, development, and release with your business model.' },
    items: [
      { title: { fa: 'اپ فروشگاهی', en: 'Shopping app' }, description: { fa: 'خرید، پرداخت و پیگیری سفارش', en: 'Shop, pay, and track orders' } },
      { title: { fa: 'اپ خدمات و رزرو', en: 'Booking app' }, description: { fa: 'درخواست خدمت و رزرو زمان', en: 'Book time and request services' } },
      { title: { fa: 'اپ سازمانی', en: 'Business app' }, description: { fa: 'ابزار کار و ارتباط تیمی', en: 'Tools for teams and workflows' } },
      { title: { fa: 'اپ آموزشی', en: 'Learning app' }, description: { fa: 'محتوا، دوره و مسیر یادگیری', en: 'Lessons, courses, and learning paths' } },
      { title: { fa: 'اپ محتوایی', en: 'Content app' }, description: { fa: 'ارائه و مدیریت محتوای دیجیتال', en: 'Publish and manage digital content' } },
      { title: { fa: 'اپ اختصاصی', en: 'Custom app' }, description: { fa: 'قابلیت‌ها مطابق ایدهٔ شما', en: 'Features shaped around your idea' } },
    ],
  },
  {
    id: 'systems',
    title: { fa: 'نرم‌افزار و سامانه', en: 'Software & systems' },
    heading: { fa: 'ابزارهایی هماهنگ با شیوهٔ کار شما', en: 'Software shaped around your work' },
    description: { fa: 'فرایندهای پراکنده را بررسی می‌کنیم و برای مدیریت، ارتباط و اجرای آن‌ها ابزار مناسب طراحی و پیاده‌سازی می‌کنیم.', en: 'We turn scattered workflows into practical tools for management, communication, and delivery.' },
    items: [
      { title: { fa: 'وب‌اپلیکیشن', en: 'Web application' }, description: { fa: 'ابزار کاربردی در مرورگر', en: 'A useful tool in the browser' } },
      { title: { fa: 'پنل مدیریت', en: 'Admin panel' }, description: { fa: 'مدیریت داده، کاربر و محتوا', en: 'Manage data, users, and content' } },
      { title: { fa: 'اتوماسیون فرایند', en: 'Workflow automation' }, description: { fa: 'سامان‌دهی کارهای تکراری', en: 'Streamline recurring tasks' } },
      { title: { fa: 'داشبورد و گزارش', en: 'Dashboard & reports' }, description: { fa: 'نمای روشن عملکرد و داده‌ها', en: 'A clear view of performance' } },
      { title: { fa: 'API و یکپارچه‌سازی', en: 'APIs & integrations' }, description: { fa: 'ارتباط میان ابزارهای کاری', en: 'Connect your working tools' } },
      { title: { fa: 'سامانهٔ اختصاصی', en: 'Custom platform' }, description: { fa: 'راهکار متناسب با نیاز شما', en: 'Built for your specific needs' } },
    ],
  },
  {
    id: 'graphics',
    title: { fa: 'گرافیک و هویت بصری', en: 'Graphics & branding' },
    heading: { fa: 'برای ایدهٔ شما یک زبان بصری می‌سازیم', en: 'Give your idea a visual language' },
    description: { fa: 'از نشانه و رنگ تا اقلام تبلیغاتی، خروجی‌ها را یکپارچه و متناسب با شخصیت برند طراحی می‌کنیم.', en: 'From marks and color to campaign materials, every visual follows a coherent brand direction.' },
    items: [
      { title: { fa: 'طراحی لوگو', en: 'Logo design' }, description: { fa: 'نشانه‌ای خوانا و ماندگار', en: 'A clear, lasting mark' } },
      { title: { fa: 'هویت بصری برند', en: 'Brand identity' }, description: { fa: 'رنگ، تایپ و قواعد کاربرد', en: 'Color, type, and usage rules' } },
      { title: { fa: 'رابط و تجربهٔ کاربری', en: 'UI / UX design' }, description: { fa: 'طراحی مسیر و صفحه‌های محصول', en: 'User journeys and product screens' } },
      { title: { fa: 'اقلام تبلیغاتی', en: 'Campaign graphics' }, description: { fa: 'بنر، پوستر و گرافیک کمپین', en: 'Banners, posters, and campaigns' } },
      { title: { fa: 'طراحی چاپی', en: 'Print design' }, description: { fa: 'کارت، بروشور و کاتالوگ', en: 'Cards, brochures, and catalogs' } },
      { title: { fa: 'بسته‌بندی', en: 'Packaging design' }, description: { fa: 'چهرهٔ محصول در قفسه و تصویر', en: 'Present products on shelf and screen' } },
    ],
  },
  {
    id: 'content',
    title: { fa: 'تولید محتوا', en: 'Content creation' },
    heading: { fa: 'محتوایی هماهنگ با هویت برند', en: 'Content that speaks in your brand voice' },
    description: { fa: 'پیام، تصویر و محتوای هر کانال را بر اساس مخاطب و هدف کسب‌وکار برنامه‌ریزی و طراحی می‌کنیم.', en: 'We plan the message and visuals for each channel around your audience and goals.' },
    items: [
      { title: { fa: 'محتوای وب‌سایت', en: 'Website content' }, description: { fa: 'متن صفحه‌ها و معرفی خدمات', en: 'Page copy and service descriptions' } },
      { title: { fa: 'محتوای شبکه‌های اجتماعی', en: 'Social media content' }, description: { fa: 'طرح و پیام متناسب با هر رسانه', en: 'Posts tailored to each channel' } },
      { title: { fa: 'محتوای محصول', en: 'Product content' }, description: { fa: 'معرفی روشن ویژگی‌ها و کاربرد', en: 'Explain features and benefits' } },
      { title: { fa: 'مقاله و بلاگ', en: 'Articles & blog' }, description: { fa: 'محتوای آموزشی و تخصصی', en: 'Educational and expert writing' } },
      { title: { fa: 'محتوای کمپین', en: 'Campaign content' }, description: { fa: 'پیام و تصویر برای یک هدف مشخص', en: 'Words and visuals for one goal' } },
      { title: { fa: 'قالب‌های گرافیکی محتوا', en: 'Content templates' }, description: { fa: 'قالب منسجم برای انتشار مستمر', en: 'A consistent look for recurring posts' } },
    ],
  },
] as const

export const processSteps = [
  {
    number: '01', enLabel: 'Discovery',
    title: { fa: 'مشاوره و اعلام نیاز', en: 'Discovery & consultation' },
    body: {
      fa: 'در گفت‌وگوی اولیه نیازهای کسب‌وکار، مخاطبان، اهداف و محدودیت‌های پروژه را می‌شناسیم. خروجی این مرحله تعریف مسئله و تصویری روشن از محدوده کار است.',
      en: 'We discuss your business goals, audience, requirements and constraints, then define the challenge and the initial project scope.',
    },
    note: { fa: 'شناخت مسئله و هدف', en: 'Goals & requirements' },
  },
  {
    number: '02', enLabel: 'Proposal',
    title: { fa: 'ارسال پروپوزال', en: 'Project proposal' },
    body: {
      fa: 'بر اساس نیازهای جمع‌بندی‌شده، پیشنهاد اجرایی شامل دامنه خدمات، مراحل تحویل، زمان‌بندی پیشنهادی و برآورد هزینه ارائه می‌کنیم تا تصمیم‌گیری آگاهانه باشد.',
      en: 'We present a practical proposal covering scope, deliverables, an estimated schedule and budget, so you can decide with clarity.',
    },
    note: { fa: 'محدوده کار و برآورد شفاف', en: 'Clear scope & estimate' },
  },
  {
    number: '03', enLabel: 'Contract',
    title: { fa: 'توافق و عقد قرارداد', en: 'Agreement & contract' },
    body: {
      fa: 'پس از توافق روی دامنه و شرایط همکاری، تعهدات دو طرف، نقاط تحویل، حقوق مالکیت و چارچوب پشتیبانی در قرارداد مشخص می‌شود.',
      en: 'Once we agree on the project, we formalize deliverables, milestones, ownership, responsibilities and support terms in writing.',
    },
    note: { fa: 'تعهدات و نقاط تحویل مشخص', en: 'Documented milestones' },
  },
  {
    number: '04', enLabel: 'Design',
    title: { fa: 'طراحی تجربه و رابط کاربری', en: 'UX & interface design' },
    body: {
      fa: 'معماری اطلاعات، جریان‌های اصلی کاربر و رابط‌های بصری در ابزارهایی مانند Figma طراحی می‌شوند. پیش از توسعه، مسیرهای کلیدی را با شما مرور و اصلاح می‌کنیم.',
      en: 'We shape information architecture, key user flows and visual interfaces in tools such as Figma, then review the designs before implementation.',
    },
    note: { fa: 'بازبینی و تأیید طرح', en: 'Review before implementation' },
  },
  {
    number: '05', enLabel: 'Build',
    title: { fa: 'کدنویسی و اجرا', en: 'Development & testing' },
    body: {
      fa: 'طراحی تأییدشده را به محصول قابل استفاده تبدیل می‌کنیم؛ پیاده‌سازی فرانت‌اند و بک‌اند، یکپارچه‌سازی‌ها، کنترل کیفیت و بررسی عملکرد در این مرحله انجام می‌شود.',
      en: 'Approved designs become a working product. We build the frontend, backend and integrations, then check functionality, quality and performance.',
    },
    note: { fa: 'توسعه و کنترل کیفیت', en: 'Build, test & iterate' },
  },
  {
    number: '06', enLabel: 'Launch',
    title: { fa: 'انتشار و پشتیبانی', en: 'Launch & ongoing support' },
    body: {
      fa: 'پس از آزمون نهایی و تأیید تحویل، محصول منتشر و دسترسی‌ها و مستندات توافق‌شده منتقل می‌شود. نگهداری و توسعه بعدی بر اساس قرارداد ادامه پیدا می‌کند.',
      en: 'After final checks and approval, we deploy the product and hand over agreed access and documentation. Ongoing support follows the contract.',
    },
    note: { fa: 'تحویل، استقرار و نگهداری', en: 'Delivery & maintenance' },
  },
]
